import Pergola1 from '../assets/ProtectionsSolaire/Pergolas/imagePergola.png'
import Pergola2 from '../assets/ProtectionsSolaire/Pergolas/Pergola2.png'
import Pergola3 from '../assets/ProtectionsSolaire/Pergolas/Pergola3.jpeg'

export const pergolas = {
    PergolaBioclimatique: {
        titre: "Pergolas bioclimatiques",
        // eslint-disable-next-line no-multi-str
        intro: "Conçues en aluminium thermolaqué, nos pergolas allient design contemporain, robustesse et confort. Grâce à leur système de toiture innovant, elles permettent de contrôler la lumière, la ventilation et la protection contre les intempéries. \
        Que ce soit pour une maison, une terrasse, un jardin ou un projet professionnel, nos pergolas s’adaptent à tous les styles d’architecture et à toutes les configurations.",
        avantages: [
            "Protection contre le soleil et la pluie",
            "Régulation naturelle de la température",
            "Structure aluminium durable",
            "Design moderne et personnalisable"
        ],
        items: [
            {
                titre: "Pergola bioclimatique classique",
                image: Pergola1,
                intro: "Élégance et confort au quotidien",
                presentation: "La pergola bioclimatique classique est la solution idéale pour créer un espace extérieur confortable et modulable. Grâce à sa toiture à lames orientables, vous pouvez ajuster l’ensoleillement et la ventilation selon vos besoins.",
                disponibilites: [
                    "Formats dipsonibles : 3x3m 3x4m",
                    "Disponible en version manuelle ou motorisée",
                    "Gouttières intégrées dans les poteaux pour une meilleure evacuation de l'eau"
                ],
                fiche: null,
                prix: "Chaque projet étant unique, le prix est établi sur devis",
                conclusion: "Conçue pour allier confort et esthétisme, cette pergola permet de gérer naturellement la lumière, de se protéger de la pluie, tout en apportant un design moderne et une installation simple et rapide."
            },
            {
                titre: "Pergola bioclimatique grand format",
                image: Pergola2,
                intro: "Pensée pour les grandes terrasses",
                // eslint-disable-next-line no-multi-str
                presentation: "La pergola bioclimatique grand format dispose d’une structure renforcée et de lames orientables grand format, permettant de couvrir de grandes surfaces tout en conservant une excellente stabilité.\
                 Elle est particulièrement adaptée aux grandes terrasses, jardins ou espaces professionnels (restaurants, hôtels, espaces lounge).",
                disponibilites: [
                    "Formats dipsonibles : 3x5m 3x6m 4x4m 4x5m 4x6m",
                    "Disponible en version manuelle ou motorisée",
                    "Gouttières intégrées dans les poteaux pour une meilleure evacuation de l'eau"
                ],
                fiche: null,
                prix: "Chaque projet étant unique, le prix est établi sur devis",
                conclusion: "Grâce à ses grandes portées et sa structure renforcée, cette pergola au design architectural haut de gamme est idéale pour aménager et valoriser les grands espaces."
            },
            {
                titre: "Pergola à toiture rétractable",
                image: Pergola3,
                intro: "Une ouverture totale sur le ciel",
                // eslint-disable-next-line no-multi-str
                presentation: "La pergola à toiture rétractable offre une expérience unique grâce à son toit entièrement ouvrant, comparable à un toit panoramique.\
                 Lorsque la toiture est ouverte, vous profitez pleinement du soleil. Une fois fermée, elle protège efficacement contre la pluie et les intempéries.",
                disponibilites: [
                    "Formats dipsonibles : 3x3m 4x3m 6x3m",
                    "Gouttières intégrées dans les poteaux pour une meilleure evacuation de l'eau"
                ],
                fiche: null,
                prix: "Chaque projet étant unique, le prix est établi sur devis",
                conclusion: "Grâce à ses grandes portées et sa structure renforcée, cette pergola au design architectural haut de gamme est idéale pour aménager et valoriser les grands espaces."
            },
        ]
    }
}